import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
} from "../../../components/Block/Block";

const HomePublic = () => {
  const auth = useSelector((state) => state.auth);

  return (
    <>
      <BlockHead>
        <BlockContent className="text-center">
          <BlockTitle tag="h4">باشگاه بیلیارد توپ سیاه</BlockTitle>
          <BlockDes>
            <p>به سامانه باشگاه بیلیارد توپ سیاه خوش آمدید</p>
          </BlockDes>
        </BlockContent>
      </BlockHead>

      <div className="text-center">
        <Link className="btn btn-primary btn-lg " to="/auth/login">
          ورود به پنل کاربری
        </Link>
      </div>
      <div className="text-center pt-4 pb-3">
        <h6 className="overline-title overline-title-sap">
          <span>اطلاعات تماس</span>
        </h6>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <span className="fw-bold">شماره تماس</span>
        <a href="tel:09162453889">09162453889</a>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <span className="fw-bold">پست الکترونیک</span>
        <a href="mailto:info@black-ball.ir" className="ellipsis" dir="ltr">
          info@black-ball.ir
        </a>
      </div>
    </>
  );
};

export default HomePublic;
